import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class StartRequestInfo  {
    _originalTypeClassName = "zvelton_Backoffice.BO.StartRequestInfo";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
StartRequestInfo.translate = translateService;
}
this.Credits = null;
this.StartRequestInfoKey = null;
this._key = this.StartRequestInfoKey = 0; 
}

static translate: TranslateService;
_key: any;
Credits:any;
AppInfo:any;
private _StartRequestInfoKey:any;
get StartRequestInfoKey(): any {
    return this._StartRequestInfoKey;
  }
set StartRequestInfoKey(value: any) {
    this._StartRequestInfoKey = value;
    this._key = value;
  }
static setAppInfo = ($this, value) => {
var oldValue = $this.AppInfo;
$this.AppInfo = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.StartRequestInfoKey == null || $this.StartRequestInfoKey == 0;
            }


}